<div class="w-full h-screen" id="export-results">
  <app-header />
  <div class="border-l h-screen-16 flex overflow-x-hidden">
    <div class="w-full">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
